import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';
import { Badge as BadgeComponent } from '@prisjakt/ui/badge';

export const DesktopOnly = styled.div`
  ${media.mediumDown`display: none;`}
`;

interface IBadge {
  showCircles?: boolean;
}
export const BadgeDesktop = styled(BadgeComponent).attrs({
  color: 'BLUE',
})<IBadge>(
  props => css`
    display: none;
    ${media.largeUp`
      display: ${props.showCircles === true ? 'none' : 'inline-flex'};
    `}
  `
);

export const BadgeMobile = styled(BadgeComponent).attrs({
  color: 'BLUE',
  circular: true,
})<IBadge>(
  props => css`
    ${media.largeUp`display: ${
      props.showCircles === true ? 'inline-flex' : 'none'
    };`}
  `
);

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  margin-right: ${layout.measurements.spacingTiny};
`;

export const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: center;
  gap: ${layout.measurements.spacingSmall};
  margin-right: ${layout.measurements.spacingSmall};
  ${media.mediumDown`
    margin-right: ${layout.measurements.spacingTiny};
  `}
`;
